import axios from 'axios';
import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router';
import { ErrorToast } from '../../components';
import Spinner from '../../components/common/Spinner';

export const Simplicity = () => {
  const history = useHistory();
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);

  const redirectUri = searchParams.get('redirect_uri');
  const userId = searchParams.get('userId');

  const openDeepLink = (deepLink: string) => {
    window.location.href = deepLink;
  };

  const generateSimplicityToken = async () => {
    try {
      const { data } = await axios.post(`/simplicity/onetime/generate`);
      const deepLink = `${redirectUri}?userId=${userId}&token=${data.data.token}`;
      openDeepLink(deepLink);
    } catch (e) {
      ErrorToast();
    }
  };

  useEffect(() => {
    if (userId) {
      generateSimplicityToken();
    } else {
      history.push(`/login?simplicity=true&redirect_uri=${redirectUri}`);
    }
  }, []);

  return <Spinner fullScreen={true} />;
};
